<template>
  <div class="devOps_producerSpaceReportHome" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="职能组织" prop="department" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.department" collapse-tags filterable
                   placeholder="请选择职能组织">
          <el-option v-for="(key, value) in NEWTEXTORGSCHART" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="团队" prop="team" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.teamId" collapse-tags filterable
                   placeholder="请选择团队"  multiple>
          <el-option v-for="(key, value) in teamList" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人员" prop="user_id_filter" :label-width="formLabelWidth">
        <el-select :style="iptStyle" filterable  clearable collapse-tags size="mini" v-model="form.user_id_filter"  placeholder="请选择人员">
          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="项目体系" prop="systemId" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.systemId" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem" :key="key" :label="key" :value="value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称">
        <el-input :style="iptStyle" placeholder="请输入" v-model="form.projectName" />
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate" label-width="80px">
        <el-date-picker value-format="yyyy-MM-dd" :style="iptStyle" :clearable = "false" v-model="form.startDate"
                        type="date" placeholder="选择开始日期" :picker-options="pickerOptions_startTime" />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate" label-width="80px">
        <el-date-picker value-format="yyyy-MM-dd" :style="iptStyle" :clearable = "false" v-model="form.endDate"
                        type="date" placeholder="选择结束日期" :picker-options="pickerOptions_endTime"/>
      </el-form-item>
        <el-form-item>
          <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                      @click.stop="formSearch('reset','search')">查询
          </el-button>

        </el-form-item>
      <div class="time-box">
        <el-button @click="searchTime(7)" size="mini">本周</el-button>
        <el-button @click.stop="searchTime(1)"  size="mini">过去一周</el-button>
        <el-button @click.stop="searchTime(2)" size="mini">过去两周</el-button>
        <el-button @click.stop="searchTime(3)" size="mini">过去一个月</el-button>
        <el-button @click.stop="searchTime(4)" size="mini">未来一周</el-button>
        <el-button @click.stop="searchTime(5)" size="mini">未来两周</el-button>
        <el-button @click.stop="searchTime(6)" size="mini">未来一个月</el-button>
      </div>
      <el-button size="mini" type="warning"  @click.stop="showGatt">分布图展示</el-button>
      <el-button size="mini" type="warning"  @click.stop="showBar">人效展示</el-button>
    </el-form>
    <!-- #endregion 表单搜索部分 -->
    <!-- #region 表格部分 -->
    <div style="height: 57vh;position: relative;">
      <el-table height="100%" stripe :header-cell-style="getCellClass"  row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @expand-change="showDetailData" :default-expand-all="allTable">
        <el-table-column prop="user" fixed="left" label="姓名" :show-overflow-tooltip="true" width="100">
          <template slot-scope="scope">
            <span>{{scope.row.user?scope.row.user.nameZh: ''}} {{scope.row.user? '('+ scope.row.user.nameEn + ')': ''}}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="department"  align="center" width="120" label="职能组织" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="team" label="团队" :show-overflow-tooltip="true" width="100">
        </el-table-column>
        <!-- <el-table-column prop="costWorkHour" align="center" width="120" label="人员负荷" :show-overflow-tooltip="true" :render-header="renderHeader">
          <template slot-scope="scope">
            <span>{{scope.row.costWorkHour}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="undo_task_hour" align="center" width="123" label="未完成总工时" :show-overflow-tooltip="true" :render-header="renderHeader">
          <template slot-scope="scope">
            <span>{{scope.row.undo_task_hour}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bug_num_ratio" align="center" width="100" label="BUG任务比" :show-overflow-tooltip="true" :render-header="renderHeader">
          <template slot-scope="scope">
            <span v-if="scope.row.bug_num_ratio!==undefined">{{(scope.row.bug_num_ratio)}}</span>
            <span v-else>{{(scope.row.bug_num_ratio)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="finsh_work_hour" align="center" width="80" label="人效" :show-overflow-tooltip="true" :render-header="renderHeader">
        </el-table-column>
        <el-table-column prop="task_finish_work_ratio" align="center" width="123" label="标准任务人效" :show-overflow-tooltip="true" :render-header="renderHeader">
        </el-table-column>
        <el-table-column prop="finsh_work_num" align="center" width="155" label="完成任务平均工时" :show-overflow-tooltip="true" :render-header="renderHeader">
        </el-table-column>
        <!-- <el-table-column prop="delayTask" align="center" width="100" label="延期任务数" :show-overflow-tooltip="true">
        </el-table-column> -->
        <el-table-column prop="task_type" align="center" width="80" label="类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
          <span v-if="scope.row.task_type && taskType[scope.row.task_type]">
            {{taskType[scope.row.task_type]}}
          </span>
          <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskCount" align="center" min-width="300" label="任务" :show-overflow-tooltip="true">
          <template slot-scope="scope" >
            <span  class="table_text_click_new" v-if="scope.row.taskId && scope.row.taskName" @click="linkFrom(9, 'tid',scope.row.taskId,scope.row.task_type)">
              {{scope.row.taskName}}
            </span>
            <span v-else>{{scope.row.taskCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="costWorkHour" label="工时" width="60" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.estimate_work_hour">{{scope.row.estimate_work_hour}}</span>
            <span v-else>{{scope.row.costWorkHour}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="revisionHour" align="center" width="160" label="开发联调工时" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="demandCount" label="需求" min-width="190" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="table_text_click_new" v-if="scope.row.demandId && scope.row.demandName" @click="linkFrom(3, 'pid',scope.row.demandId)">
              {{scope.row.demandName}}
            </span>
            <span v-else>{{scope.row.demandCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="projectSystemCount" label="项目体系" width="140" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="projectCount" label="项目" min-width="200" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="table_text_click_new" v-if="scope.row.projectId && scope.row.projectId" @click="linkFrom(11, 'proId',scope.row.projectId)">
              {{scope.row.projectName}}
            </span>
            <span v-else>{{scope.row.projectCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nowFinishDate" label="预计完成时间" width="120" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="finishTaskCount" label="任务状态" width="100" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.status_desc">{{scope.row.status_desc}}</span>
            <span v-else>{{scope.row.finishTaskCount}} / {{scope.row.taskCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="submitWorkHour" label="进度" width="60" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.processRate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="metting_sec" label="会议耗时" width="100" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="delay_code_reason" label="延期原因" width="100" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="entry_date" label="入职日期" width="100" align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->
    <!-- #region 分页部分 -->
    <div class="block devOpsSpace_page">
      <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                     layout="total, prev, pager, next, sizes" :total="count">
      </el-pagination>
    </div>
    <!-- #endregion -->
    <!-- #region dialog 部分 -->
    <Demand v-if="dialogVisible.demand" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.demand'
            :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :tabid="tabid"/>
    <Task v-if="dialogVisible.task" :back="back" :dialogVisible='dialogVisible.task' :hideDialogVisible="hideDialogVisible"
          :formInfo="checkedInfo"  :tabid="tabid"/>
    <ToDevelop v-if="dialogVisible.toDevelop" :dialogVisible='dialogVisible.toDevelop'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <Developing v-if="dialogVisible.developing" :dialogVisible='dialogVisible.developing'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ToTest v-if="dialogVisible.toTest" :dialogVisible='dialogVisible.toTest' :hideDialogVisible="hideDialogVisible"
            :formInfo="checkedInfo" />
    <TestEnvTesting v-if="dialogVisible.testEnvTesting" :dialogVisible='dialogVisible.testEnvTesting'
                    :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <PreEnvTesting v-if="dialogVisible.preEnvTesting" :dialogVisible='dialogVisible.preEnvTesting'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <UatTesting v-if="dialogVisible.uatTesting" :dialogVisible='dialogVisible.uatTesting'
                :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ToRelease v-if="dialogVisible.toRelease" :dialogVisible='dialogVisible.toRelease'
               :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <ProEnvTesting v-if="dialogVisible.proEnvTesting" :dialogVisible='dialogVisible.proEnvTesting'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />
    <Online v-if="dialogVisible.online" :dialogVisible='dialogVisible.online' :hideDialogVisible="hideDialogVisible"
            :formInfo="checkedInfo" />
    <!-- #endregion dialog 部分 -->
    <CreateProject v-if="dialogVisible.project" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.project'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" />

    <RecordProject v-if="dialogVisible.record"   :back="back"  :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.record'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></RecordProject>

    <RecordIndex v-if="dialogVisible.recordIndex"  :startDate="this.form.startDate" :endDate="this.form.endDate" :back="back"  :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.recordIndex'
                 :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :searchForm="form" :pageNum="currentPage" :pagecSize="pageSize"></RecordIndex>
    <PersonDetail v-if="dialogVisible.personDetail"  :startDate="this.form.startDate" :endDate="this.form.endDate" :back="back"  :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.personDetail'
                  :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo" :searchForm="form" :pageNum="currentPage" :pagecSize="pageSize"></PersonDetail>
    <Menu />
  </div>
</template>
<script>
import { Demand, Task, ToDevelop, Developing, ToTest, TestEnvTesting, PreEnvTesting, UatTesting, ToRelease, ProEnvTesting, Online } from '@/views/tops/devOps/producerSpace/components'
import {
  getDevOpsSpaceProducerListApi,
  getDevOpsSpaceNewReviewListApi,
  getDevOpsSpacePerformanceDetailListApi,
  getDevOpsSpacePerformanceListApi,
  getDevOpsSpaceTeamListApi
} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import Menu from '@/components/menu/index.vue'
import { mapState, mapMutations } from 'vuex';
import Review from '@/views/tops/devOps/producerSpace/review.vue'
import CreateProject from "@/views/tops/devOps/producerSpace/components/createProject.vue";
import RecordProject from "@/views/tops/devOps/producerSpace/components/recordProject.vue";

import RecordIndex from "@/views/tops/devOps/reporterSpace/components/performanceStatisticsIndexpage/index.vue";
import PersonDetail from "@/views/tops/devOps/reporterSpace/components/performanceStatisticsIndexpage/personDetail.vue";
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceSystemApi} from "@/server/tops/base";

export default {

  components: {RecordProject, CreateProject, Demand, Task, ToDevelop, Developing, ToTest, TestEnvTesting, PreEnvTesting, UatTesting, ToRelease, ProEnvTesting, Online, Menu , Review, RecordIndex, PersonDetail},
  props: {
    tabid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 表单搜索条件
      form: {
        teamId:'',
        department:'数字技术管理部',
        systemId: '',
        projectName: '',
        startDate: '',
        endDate: '',
        user_id_filter:'',
      },
      allSystem:[],
      // 需求列表
      tableData: [],
      tableDataAll:[],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      pickerOptions_startTime: {
        disabledDate: (time) => {
          return this.disabledDate(time)
        }
      },
      pickerOptions_endTime: {
        disabledDate: (time) => {
          return this.disabledDate(time)
        }
      },
      // 弹出层部分
      dialogVisible: {
        demand: false,
        task: false,
        toDevelop: false,
        developing: false,
        toTest: false,
        testEnvTesting: false,
        preEnvTesting: false,
        uatTesting: false,
        toRelease: false,
        proEnvTesting: false,
        online: false,
        project: false,
        record: false,
        recordIndex: false,
        personDetail: false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      tableLoading: false,
      checkedTables: ['reviewed_status','o_aelt', 'o_pdt', 'project_system', 'demander', 'user_pm', 'priority', 'p_status', 'p_issue_status', 'plt', 'progress', 'taskInfo.module', 'taskInfo.user_rd', 'taskInfo.user_qa', 'taskInfo.status', 'taskInfo.task_progress', 'taskInfo.issue'],
      back : '',
      teamList: [],
      allUser: {},
      taskType:{
        'd':'开发任务',
        't':'测试任务',
        'o':'其他任务',
        'g':'BUG',
      }
    };
  },
  async created() {
    let checkedTables = getStorage('checkedTables', 'localStorage')
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    this.checkedTables = checkedTables ? checkedTables.split(',') : this.checkedTables;
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsStatusList',{type:''})
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          NEWREVIEWSTATUS: (state) => state.devOps.NEWREVIEWSTATUS,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
          NEWTEXTORGSCHART: (state) => state.devOps.NEWTEXTORGSCHART,
        }
    ),
    /*评审状态*/
    reviewedStr() {
      let str = ''
      this.form.reviewed_status.forEach(item => {
        str += this.allSelect.TEXTREVIEWSTATUS[item] + ' '
      })
      return str;
    },
    /*需求状态 */
    pStrStatus() {
      let str = ''
      this.form.p_status.forEach(item => {
        str += this.allSelect.TEXTPISSUESTATUS[item] + ' '
      })
      return str;
    },
  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { pid = '', proId = '', teamId = '' , department = ''} = this.$route.query;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : [], title: pid, reviewer: username};

    if (pid || proId ) {
      this.form.status = '';
      this.form.reviewId = '';
      if(pid) this.form.demandName = pid;
      if(proId) this.form.projectName = proId;
    }
    if(teamId){
      this.form.teamId = teamId.split(',');
      this.form.department = '';
    }
    if(department){
      this.form.department = department;
    }

    let nowday = new Date().getDay();
    let day = nowday || 7;
    /*  let start_date = new Date(this.$moment(new Date()).format("YYYY-MM-DD")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) - 7 * 60 * 60 * 24 * 1000;
      let end_date = start_date + 60 * 60 * 24 * 1000 * 4;

      this.form.startDate = this.formatDate(start_date);
      this.form.endDate = this.formatDate(end_date);*/
    this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7);
    this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime()-60 * 60 * 24 * 1000);
    this.$nextTick(async () => {
      await this.getSystem();
      await this.formSearch();
      await this.getDevOpsSpaceAllUser();
      // this.autoDialogDetailPop(this.tableData)
    })
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#f3f3f3;color:#909399;font-size:14px;"
    },
    // 全部收起
    allPack() {
      const list = document.querySelectorAll(".el-table__expand-icon");
      for (let i = 0; i < list.length; i++) {
        if (!list[i].className.includes("el-table__expand-icon--expanded")) {
          continue;
        } else {
          list[i].click();
        }
      }
    },
    linkFrom(tabid,typeId,busId = '',task_type = ''){
      // let url = `${window.location.origin}/#/devOpsProducerSpace?tabid=${tabid}&${typeId}=${busId}`;
      let url = `${window.location.origin}/Home/devOpsTaskSpace/devTask?${typeId}=${busId}`;

      if(typeId === 'tid' && task_type){
        if(task_type === 'd'){
          url = `${window.location.origin}/Home/devOpsTaskSpace/devTask?${typeId}=${busId}`
        }
        if(task_type === 't'){
          url = `${window.location.origin}/Home/devOpsTaskSpace/testTask?testId=${busId}`
        }
        if(task_type === 'o'){
          url = `${window.location.origin}/Home/devOpsTaskSpace/otherTask?${typeId}=${busId}`;
        }
        if(task_type === 'g'){
          url = `${window.location.origin}/Home/devOpsTaskSpace/bugTask?bid=${busId}`;
        }
      }
      //需求
      if(typeId === 'pid'){
        url = `${window.location.origin}/Home/devOpsDemandSpace/demand?${typeId}=${busId}`;
      }
      //项目
      if(typeId === 'proId'){
        url = `${window.location.origin}/Home/devOpsProjectSpace/project?${typeId}=${busId}`;
      }
      window.open(url)
    },
    // 全部展开
    allExpansion() {
      this.allTable = true;
      this.refTable = false;
      this.$nextTick(() => {
        this.refTable = true;
      });
    },
    showDetailData(row, rowList){
      if(rowList){
        try{
          let params = {...this.form,user_set:row.id};
          getDevOpsSpacePerformanceDetailListApi(params).then((ret)=>{
            if(ret.data.length > 0) {
              this.formatTableDataDetail(ret.data, row.id);
            }
          })

        }catch (error){
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        }


      }
    },
    formatDate(time) {
      let date = new Date(time);
      let myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = '0' + mymonth;
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday;
      }
      return (myyear + '-' + mymonth + '-' + myweekday);
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表单搜索
    async formSearch(type,key) {
      if((this.form.startDate && !this.form.endDate) || (!this.form.startDate && this.form.endDate)){
        this.$notify({
          message: "请选择日期",
          type: "error",
        })
        return false;
      }
      if(this.form.startDate && this.form.endDate){
        if(this.form.startDate > this.form.endDate){
          this.$notify({
            message: "结束日期必须大于开始日期",
            type: "error",
          })
          return false;
        }
      }
      /*  if (key === 'domain') {
          this.filterSelect({ type: 'domain_module', val: this.form.domain })
        }*/
      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      this.loading = true;
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        let ret = await getDevOpsSpacePerformanceListApi(params);
        this.tableData = this.formatTableData(ret.data);
        this.cacheTableData = this.formatTableData(ret.data);
        this.currentPageLength = ret.data.length;
        this.count = ret.count;
        this.loading = false;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
        this.loading = false;
      } finally {
        this.loading = false;
      }
      this.allPack();
      return false;
    },
    // 判断是否需要直接弹详情
    autoDialogDetailPop(tableData) {
      const { pid = '', tid = '', sid = '' } = this.$route.query;
      if (!tableData.length) return;
      if (pid && !tid && !sid) { // 弹需求详情
        this.showDialogVisible('demand', tableData[0])
        return;
      }
      if (pid && tid && !sid) { // 弹任务详情
        this.showDialogVisible('task', tableData[0])
        return;
      }
      if (pid && tid && sid) { // 弹阶段详情
        this.showDialogVisible(this.allSelect.TEXTTASKSTATUSDIOLOGVISIBLE[tableData[0].taskInfo.status], tableData[0])
        return;
      }
      return;
    },
    disabledDate(time) {
      const nowTime = Date.now() - 365 * 60 * 60 * 24 * 1000;
      return time.getTime() <= nowTime;
    },
    // 格式化数据
    formatTableData(data) {
      let arr = []
      data.forEach((o,i) => {
        const obj = {...this.commonTableDataObj(o),undo_task_hour:o.undo_task_hour,bug_num_ratio:o.bug_num_ratio,id: o.user.id, processRate: o.processRate +'%',finsh_work_hour: o.finsh_work_hour + '%',entry_date: o.entry_date,finsh_work_num: o.finsh_work_num,task_finish_work_ratio: o.task_finish_work_ratio + '%',children:[{
            id: i,
          }]};
        arr.push(obj)
      })
      return arr;
    },
    showGatt(){
      this.dialogVisible.recordIndex = true;
    },
    showBar(){
      this.dialogVisible.personDetail = true;
    },
    // 格式化数据
    formatTableDataDetail(data,uid) {
      this.tableData.forEach((res,index)=>{
        if(uid == res.id){
          let arr = [];
          data.forEach((r)=>{
            arr.push({
              id:r.taskId,
              costWorkHour:r.costWorkHour,
              revisionHour:r.revisionHour,
              estimate_work_hour:r.estimate_work_hour,
              totalWorkhHour: r.totalWorkhHour,
              delayTask:r.delayTask,
              taskCount:'【'+ r.taskId+'】'+r.taskName,
              demandCount: '【'+ r.demandId+'】'+r.demandName,
              projectSystemCount: r.projectSystem,
              projectCount: '【'+ r.projectId+'】'+r.projectName,
              planFinishDate: r.planFinishDate,
              finishTaskCount: r.status_desc,
              nowFinishDate:r.nowFinishDate,
              status_desc: r.status_desc,
              submitWorkHour: r.submitWorkHour,
              processRate: r.task_process,
              pColor: r.newColor,
              taskId:r.taskId,
              demandId:r.demandId,
              projectId: r.projectId,
              taskName:'【'+ r.taskId+'】'+r.taskName,
              demandName: '【'+ r.demandId+'】'+r.demandName,
              projectName: '【'+ r.projectId+'】'+r.projectName,
              task_type: r.task_type,
              delay_code_reason: r.delay_code_reason,
              finsh_work_hour: r.finsh_work_hour + '%',

            });
          })
          this.tableData[index]['children'] = arr;
        }

      })
      /*  data.forEach(o => {
          const obj = {...this.commonTableDataObj(o),id: o.user.id, children:[{
              id: o.user.id,
            }]};
          arr.push(obj)
        })
        return arr;*/
    },
    changeTableData(data) {
      let arr = []
      data.forEach(o => {
        const obj = { p_issue_status: o.p_status, ...this.commonTableDataObj(o), processRate: o.processRate +'%' };
        arr.push(obj)

      })
      return arr;
    },
    // 公共部分逻辑
    commonTableDataObj(o) {
      const { user, department, nowFinishDate,costWorkHour, revisionHour,totalWorkhHour, delayTask, taskCount, demandCount ,projectSystemCount,projectCount,planFinishDate,finishTaskCount,submitWorkHour,team,processRate,metting_sec} = o;
      return {  user, department, costWorkHour, nowFinishDate,revisionHour,totalWorkhHour, delayTask, taskCount, demandCount ,projectSystemCount,projectCount,planFinishDate,finishTaskCount,submitWorkHour,team,processRate,metting_sec:this.secondsToHours(metting_sec)};
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:8px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:8px 0;";
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type !== 1 && item.user_type !== 13){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.allUser = arr;
    },
    // 格式化tableData数据
    formatSortTableData() {
      let arr = []
      this.tableData.forEach(item => {
        if (item.id) {
          const ls = this.tableData.filter(itm => {
            return itm.sortId.startsWith(item.id)
          })
          arr.push(ls)
        }
      })
      return arr;
    },
    // 排序需求列表
    setTableDateHead(arr, order) {
      let newArr = [], existDates = [], noExistDates = [];
      arr.forEach(t => {
        t[0].maxDate ? existDates.push(t) : noExistDates.push(t);
      })
      existDates.sort((a, b) => {
        return order === 'descending' ? b[0].maxDate - a[0].maxDate : a[0].maxDate - b[0].maxDate;
      })
      let pArr = existDates.concat(noExistDates);
      pArr.forEach(item => {
        let cacheIdx = 0;
        item.forEach((itm, index) => {
          if (index === 0) {
            const pi = item.filter((it, idx) => {
              if (it.id) {
                cacheIdx = idx;
                return true;
              }
            })
            itm = { ...pi[0], ...itm }
          }
          if (index === cacheIdx && cacheIdx !== 0) {
            itm = { sortId: itm.sortId, taskInfo: itm.taskInfo }
          }
          newArr.push(itm)
        })
      })
      return newArr;
    },
    // 排序事件
    async sortChange(column) {
      const { prop, order } = column;
      this.tableData = this.cacheTableData;
      if(prop === 'expect_finish_date') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.expect_finish_date) - Date.parse(a.expect_finish_date) : Date.parse(a.expect_finish_date) - Date.parse(b.expect_finish_date);
        })
      }
      if(prop === 'plan_finish_date') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.plan_finish_date) - Date.parse(a.plan_finish_date) : Date.parse(a.plan_finish_date) - Date.parse(b.plan_finish_date);
        })
      }
    },
    async SearchAll() {
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = 1
        params.pageSize = 9999999999999
        this.loading = true;
        const ret = await getDevOpsSpaceNewReviewListApi(params);
        this.tableDataAll = ret.data;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
      return false;
    },
    // 弹出模板
    async showDialogVisible(type, row , back = '') {
      if (type === 'releaseing') {
        return;
      }
      let newRow = {...row};
      /*if(type === 'addTest'){
        let taskInfo = {};
        newRow = {...row,taskInfo:row};
      }*/
      if(type === 'project'){
        newRow = {name : row.project_name, id: row.project_id}
      }
      if(type === 'demand'){
        newRow = {name : row.demand_name, id: row.id}
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = newRow;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      let pid = '';
      if(nextStep === 'demand'){
        pid = this.checkedInfo.id;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        const params = nextStep === 'demand' ? { demandName: this.checkedInfo?.id} : ''
        const ret = await getDevOpsSpaceNewReviewListApi(params);
        const tableData = ret.data || [];
        this.checkedInfo = tableData[0];
        this.checkedInfo.next = (nextStep === 'demand')
        if(nextStep === 'demand'){
          this.checkedInfo = {id:pid};
        }
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    changeReset(){
      this.form.status = '';
      this.form.reviewId = '';
      this.form.systemId = '';
      this.form.projectName = '';
      this.form.demandName = '';
      this.form.reviewId = '';
      this.form.serach_time = '';
      this.form.reviewed_status = '';
    },
    searchTime(type){
      if(type === 1){
        //过去一周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 2){
        //过去两周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 7 * 2);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 3){
        //过去一个月
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * 30);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime());
      }
      if(type === 4){
        //未来一周
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime() + 60 * 60 * 24 * 1000 * 7);
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime());
      }
      if(type === 5){
        //未来两周
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime() + 60 * 60 * 24 * 1000 * 7 * 2);
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime());
      }
      if(type === 6){
        //未来一个月
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 23:59:59")).getTime() + 60 * 60 * 24 * 1000 * 30);
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime());
      }
      if(type === 7){
        //新增 本周
        let nowday = new Date().getDay();
        let day = nowday || 7;
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1));
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) + 60 * 60 * 24 * 1000 * 6);
      }
      this.formSearch('reset','search')
    },
    changeTimeDate(timestamp){
      let dateObj = new Date(timestamp);
      // 提取所需的年、月、日等信息
      let year = dateObj.getFullYear();
      let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      let day = dateObj.getDate().toString().padStart(2, '0');
      // 构造最终的日期/时间字符串
      let formattedTime = `${year}-${month}-${day}`;
      return formattedTime;
    },
    async getSystem() {
      let arr = {};
      await getDevOpsSpaceSystemApi().then((res) => {
        res.data.forEach((item)=>{
          arr[item.id] = item.nameZh;
        });
      });
      this.allSystem = arr;
      let team = {};
      await getDevOpsSpaceTeamListApi().then((ret)=>{
        ret.data.forEach((item)=>{
          team[item.id] = item.name;
        });
      })
      this.teamList = team;
    },
    fileExport() {
      let url = `${window.location.origin}/devops/space/reporter/export?source_type=project&project_action=list`;
      for (const key in this.form) {
        const val = this.form[key];
        url += `&${key}=${this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val}`;
      }
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      url += `&pageNo=${this.currentPage}&pageSize=${this.pageSize}&username=${username}`;
      window.location.href = url;
    },
    secondsToHours(totalSeconds) {
      return Math.floor(totalSeconds / (60 * 60));
    },
    renderHeader(h,{column}){
      const contnetPerson = '当期任务时长/当期工作日时长 x 100%';
      const finishPer = '当期完成任务时长/当期工作日时长 x 100%';
      let content = contnetPerson;
      if(column.property == 'finsh_work_hour'){
        content = finishPer;

      }
      if(column.property == 'finsh_work_num'){
        content = '当期完成任务总工时/当期完成任务数';
      }
      if(column.property == 'task_finish_work_ratio'){
        content = '当期完成标准任务时长/当期工作日时长 * 100%';
      }
      if(column.property == 'undo_task_hour'){
        content = '任务池总工时';
      }

      if(column.property =='costWorkHour' || column.property == 'finsh_work_hour' || column.property == 'finsh_work_num' || column.property == 'task_finish_work_ratio'|| column.property == 'undo_task_hour' ){
        // console.log('修改表头   column=',column)
        return h('div',
            [
              h('span', column.label),
              h(
                  'el-tooltip',{
                    props:{
                      content: (()=>{ return content})(),
                      placement: 'top'
                    }
                  },
                  [h('i', {
                    class:'el-icon-question',
                    style:'margin-left:5px;cursor:pointer;'
                  })]
              )
            ],
        );
      }
      return h('div',[h('span', column.label)]);
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceReportHome {

  .link_svg {
    position: absolute;
    left: -96px;
    top: 2px;
    transform: rotate(90deg);
    cursor: pointer;
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
//.table_text_click_new {
//  text-decoration: underline;
//  color: #409EFF;
//  cursor: pointer;
//  overflow: hidden;
//  text-overflow: ellipsis;
//  white-space: nowrap; /* Prevent text wrapping */
//  //max-width: 200px; /* 设置最大宽度 */
//  display: inline-block; /* 确保max-width生效 */
//}


  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
  /* /deeep/样式穿透*/
  /*1.取消原本展开的旋转动效*/
  .el-table__expand-icon{
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  /*2.展开按钮未点击的样式是加号带边框*/
  .el-table__expand-icon .el-icon-arrow-right:before{
    content: "\e723";
    padding: 1px;
    font-size: 17px;
  }
  /*2.按钮已点击展开之后的样式是减号带边框*/
  .el-table__expand-icon--expanded .el-icon-arrow-right:before{
    content: "\e722";
  }

  // 固定列相关样式
  .el-table__fixed-right-patch {
    background-color: transparent;
  }
  .el-table__fixed-right::before,
  .el-table__fixed::before {
    background-color: transparent;
  }
  // 解决固定列高度错位问题 8px与滚动条高度相等
  .el-table__fixed-body-wrapper .el-table__body {
    padding-bottom: 8px!important;
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.tag-table{
  margin:15px 10px;
}
.review_centert{
  color:#fff;
  padding: 4px;
  border-radius: 10px;
}
.not_reviewed{
  background:#409EFF;
  opacity: 0.75;
}
.under_review{
  background:#409EFF;
}
.reviewed{
  background:#11B45C;
}
.history_reviewed{
  background:#333333;
}
.devOps_producerSpaceReview .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}


</style>
